export default __webpack_public_path__ + "4fb9b41304a6e2e7c0c55e2df2479d18.svg";